import React, { Suspense, lazy, useEffect } from "react";
import {
  BrowserRouter as Main,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import CustomCursor from "./components/CustomCursor";
import { Helmet } from "react-helmet";

// ✅ Lazy-loaded pages
const Home = lazy(() => import("./components/pages/home/home"));
const About = lazy(() => import("./components/pages/about/about"));
const Contact = lazy(() => import("./components/pages/contact/contact"));
const Blog = lazy(() => import("./components/pages/blog/blog"));
const Casestudy = lazy(() =>
  import("./components/pages/case-study/case-study")
);
const WebDev = lazy(() =>
  import("./components/pages/services/web-development")
);
const MobileApp = lazy(() =>
  import("./components/pages/services/mobile-app-development")
);
const UiUx = lazy(() => import("./components/pages/services/ui-ux-design"));
const SoftwareDev = lazy(() =>
  import("./components/pages/services/software-development")
);
const ArtificalInt = lazy(() =>
  import("./components/pages/services/artificial-intelligence")
);
const Single = lazy(() => import("./components/pages/single/single"));
const CaseStudyDetail = lazy(() =>
  import("./components/pages/case-study-detail/case-study-detail")
);
const TermCond = lazy(() =>
  import("./components/pages/terms-condition/terms-and-conditions")
);
const Sitemap = lazy(() => import("./components/pages/sitemap/sitemap"));
const ErrorPage = lazy(() => import("./components/ErrorPage"));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <div>
        <Helmet>
          <meta httpEquiv="cache-control" content="no-cache" />
          <meta httpEquiv="expires" content="0" />
          <meta httpEquiv="pragma" content="no-cache" />
        </Helmet>
        <Main>
          <Header />
          <CustomCursor />
          <ScrollToTop />

          {/* ✅ Suspense fallback for lazy loading */}
          <Suspense fallback={<div className="loading-screen">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/web-development" element={<WebDev />} />
              <Route path="/mobile-app-development" element={<MobileApp />} />
              <Route path="/ui-ux-design" element={<UiUx />} />
              <Route path="/software-development" element={<SoftwareDev />} />
              <Route
                path="/artificial-intelligence"
                element={<ArtificalInt />}
              />
              <Route path="/blog" element={<Blog />} />
              <Route path="/single/:slug" element={<Single />} />
              <Route path="/case-study" element={<Casestudy />} />
              <Route
                path="/case-study-detail/:slug"
                element={<CaseStudyDetail />}
              />
              <Route path="/terms-and-conditions" element={<TermCond />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </Suspense>

          <Footer />
        </Main>
      </div>
    </>
  );
}

export default App;
